/* eslint-disable */
import axios from 'ggApp/utils/requests';
import { waitForPayPalPaymentMethodReady } from '../services';

export function authorize(orderNumber) {
  return (dispatch, getState) => dispatch({
    type: 'BRAINTREE_GET_AUTH_TOKEN',
    promise: axios.post(`/orders/${orderNumber}/braintree_authorize`)
      .then(res => res.data.client_token),
  });
}

export function confirm(orderNumber, nonce, callback, errorCallback) {
  return (dispatch, getState) => dispatch({
    type: 'BRAINTREE_CONFIRM',
    promise: axios.post(`/orders/${orderNumber}/braintree_confirm`, nonce),
    callback,
    errorCallback,
  });
}

export function authorizePaypal(orderNumber, urls) {
  const
    editedUrls = {
      confirm_url: `${window.location.origin}${urls.confirm_url}`,
      cancel_url: `${window.location.origin}${urls.cancel_url}`,
    };

  return (dispatch, getState) => {
    return dispatch({
      type: 'BRAINTREE_AUTHORIZE_PAYPAL',
      promise: axios.post(`/orders/${orderNumber}/paypal_authorize`, editedUrls)
        .then(res => {
          window.location.href = res.data.checkout_url;
        }),
    })

  };
}

export function confirmPaypal(orderNumber, data) {
    return (dispatch) => {
        dispatch({
            type: 'BRAINTREE_CONFIRM_PAYPAL',
        });
        return waitForPayPalPaymentMethodReady(orderNumber, data)
            .then((result) => {
                dispatch({
                    type: 'BRAINTREE_CONFIRM_PAYPAL_SUCCESS',
                    data: result,
                });
                return result;
            })
            .catch((error) => {
                dispatch({
                    type: 'BRAINTREE_CONFIRM_PAYPAL_FAILURE',
                    data: error,
                });
                throw error;
            });
    };
}


export function submitCreditcard(submitted) {
  return ({
    type: 'SET_BT_CC_DATA',
    data: { submitted, },
  })
}

export function setStatus(data) {
  return {
    type: 'BRAINTREE_SET_STATUS',
    data,
  };
}

export function setMainData(data) {
  return {
    type: 'SET_BT_MAIN_DATA',
    data,
  };
}

export function setCreditcardData(data) {
  return {
    type: 'SET_BT_CC_DATA',
    data,
  };
}

export function setPaypalData(data) {
  return {
    type: 'SET_BT_PP_DATA',
    data,
  };
}

export function startFetching() {
  return {
    type: 'BRAINTREE_FETCHING',
  };
}

export function stopFetching() {
  return {
    type: 'BRAINTREE_STOP_FETCHING',
  };
}
